import React, { FC, useState } from 'react';
import {
  IconCont,
  MessageCont,
  MessageTitle,
  MessageDescription,
  CloseMarkContainer,
  NotificationCont,
  ExpandableMarkContainer,
} from './Notification.styles';
import { useToast } from '../../hooks';
import { IToastMessage } from '../../hooks/useToast';
import ExpandableIcon from '@/assets/icons/bigExpandableIcon.svg?react';
import CloseMark from '@/assets/icons/closeMark.svg?react';

interface INotification {
  data: IToastMessage & { style?: string; type?: string };
  closePanel?: () => void;
  isExpandable?: boolean;
}

const Notification: FC<INotification> = ({ data, closePanel = null, isExpandable = false }) => {
  const { chooseToastBackgroundColor, chooseToastType } = useToast();
  const { border, background, icon } = chooseToastBackgroundColor(data.mode);
  const { borderRadius, borderWidth } = chooseToastType(data.style ? data.style : data.type);
  const [isExpanded, setIsExpanded] = useState(true);
  return (
    <NotificationCont
      backgroundColor={background}
      borderColor={border}
      borderRadius={borderRadius}
      borderWidth={borderWidth}
      data-testid="notification-container"
    >
      <IconCont data-testid="notification-icon">{icon}</IconCont>
      <MessageCont>
        <MessageTitle data-testid="notification-title">{data?.title}</MessageTitle>
        {((isExpandable && isExpanded) || !isExpandable) && (
          <MessageDescription data-testid="notification-desc">
            {data?.description}
          </MessageDescription>
        )}
      </MessageCont>
      {isExpandable ? (
        <ExpandableMarkContainer
          data-testid="expandToast"
          isExpanded={isExpanded}
          onClick={() => setIsExpanded(prev => !prev)}
        >
          <ExpandableIcon />
        </ExpandableMarkContainer>
      ) : null}
      {closePanel ? (
        <CloseMarkContainer data-testid="closeToast" onClick={() => closePanel()}>
          <CloseMark />
        </CloseMarkContainer>
      ) : null}
    </NotificationCont>
  );
};

export default Notification;
